import { joinCn } from '../util';

const style = {
  listItem: 'p-2 overflow-hidden h-full flex-1 bg-white',
  listItemTitle: 'w-full text-headline-s',

  itemListContainer: joinCn('flex flex-col gap-1 overflow-auto py-1'),
  itemContainer: joinCn(
    'flex gap-1',
    'w-full px-2 py-1',
    '!rounded-md',
    'border border-white bg-white',
    'text-black',

    'enabled:hover:shadow-sm ',
    'enabled:active:border enabled:active:border-tertiary-200 enabled:active:bg-tertiary-200 enabled:active:font-bold enabled:active:text-secondary-300 enabled:active:shadow-none',
    'aria-pressed:border aria-pressed:border-tertiary-200 aria-pressed:bg-tertiary-200 aria-pressed:font-bold aria-pressed:text-secondary-300 aria-pressed:shadow-none',

    'disabled:text-gray-300',
  ),
  itemInfo: joinCn('flex items-center gap-2', 'flex-1'),
  itemName: joinCn('text-body-l'),
  itemNum: joinCn('text-body-s font-normal text-gray-500'),

  icon: joinCn('h-6 w-6'),
};

export default style;
